package anjuros.development.modules

import anjuros.development.components.language.ResKey
import anjuros.development.util.Res

enum class Facilities(
    val facility: ResKey,
    val icon: String

) {

    FACILITY1(
        facility = ResKey.FACILITY1,
        icon = Res.Image.facility1
    ),
    FACILITY2(
        facility = ResKey.FACILITY2,
        icon = Res.Image.facility2
    ),
    FACILITY3(
        facility = ResKey.FACILITY3,
        icon = Res.Image.facility3
    ),
    FACILITY4(
        facility = ResKey.FACILITY4,
        icon = Res.Image.facility4
    ),
    FACILITY5(
        facility = ResKey.FACILITY5,
        icon = Res.Image.facility5
    ),
    FACILITY6(
        facility = ResKey.FACILITY6,
        icon = Res.Image.facility6
    ),
    FACILITY7(
        facility = ResKey.FACILITY7,
        icon = Res.Image.facility7
    ),
    FACILITY8(
        facility = ResKey.FACILITY8,
        icon = Res.Image.facility8
    ),
    FACILITY9(
        facility = ResKey.FACILITY9,
        icon = Res.Image.facility9
    )

}